<app-nav></app-nav>
<main class="landing-main">
    <section>
        <h2>Eliminación de Datos Personales</h2>
        <article>
            <p><span>En Tutti Apps S.A. respetamos su derecho a solicitar la eliminación de los datos personales que
                    tratamos en el marco de AdminAI, ya sea que usted sea un administrador que utiliza la
                    plataforma o un consorcista que interactúa con nuestro asistente a través de WhatsApp u otro
                    canal habilitado.</span></p>
        </article>
        <article>
            <p><b>Cómo solicitar la eliminación de sus datos</b></p>
            <p>
                <span>
                    Para solicitar la eliminación de sus datos personales, envíe un correo electrónico a
                    <a class="cursor-pointer" href="mailto:soporte@tutti.ar" rel="noopener">soporte&#64;tutti.ar</a>
                    con el asunto «Eliminación de datos personales», incluyendo la información necesaria para
                    identificar su cuenta o su número de WhatsApp (según corresponda).
                </span>
            </p>
        </article>
        <article>
            <p><b>Qué pasa después de la solicitud</b></p>
            <p>
                <span>
                    Procesaremos su solicitud en un plazo máximo de 15 días hábiles y le confirmaremos por correo
                    electrónico una vez que la eliminación haya sido completada. Esta eliminación alcanza a los
                    datos personales que identifican al solicitante, sin perjuicio de la información que la
                    normativa aplicable nos exija conservar por un período adicional.
                </span>
            </p>
        </article>
        <article>
            <p><b>Marco legal</b></p>
            <p><span>El tratamiento y la eliminación de datos personales se rigen por la Ley N° 25.326 de Protección
                    de los Datos Personales de la República Argentina. Puede encontrar más información sobre cómo
                    tratamos sus datos en nuestra <a routerLink="/privacy-policy">Política de Privacidad</a>.</span>
            </p>
        </article>
    </section>
    <div class="btn-cont">
        <a routerLink="/" class="button-primary">
            Volver Atrás
        </a>
    </div>
</main>
<app-footer />
